export enum PaymentStatus {
  ENTERED = 'ENTERED',

  REQUESTED = 'REQUESTED',

  COMPLETED = 'COMPLETED',

  REJECTED = 'REJECTED',

  BOUNCED = 'BOUNCED',

  WRITE_OFF = 'WRITE_OFF',

  CREDIT_NOTE = 'CREDIT_NOTE',

  DEBIT_NOTE = 'DEBIT_NOTE',
}
